import React from 'react';
import { CONTRACT_LENGTH_OPTIONS, ContractLengthValueRestricted } from '../constants/billing';

interface ContractPeriodSelectorProps {
  value: ContractLengthValueRestricted;
  onChange: (value: ContractLengthValueRestricted) => void;
  className?: string;
}

const ContractPeriodSelector: React.FC<ContractPeriodSelectorProps> = ({ 
  value, 
  onChange, 
  className = '' 
}) => {
  // Calculate savings percentage for display (example values - adjust as needed)
  const getSavingsPercentage = (period: string): number => {
    const savingsMap: Record<string, number> = {
      '1_month': 0,
      '3_months': 5,  // 5% savings for 3 months
      '12_months': 15 // 15% savings for 12 months
    };
    return savingsMap[period] || 0;
  };

  // Get the number of months from the value
  const getMonthsFromValue = (value: string): number => {
    const match = value.match(/(\d+)_months/);
    return match ? parseInt(match[1], 10) : 1;
  };

  return (
    <div className={`contract-period-selector ${className}`}>
      <div className="period-buttons-container">
        {CONTRACT_LENGTH_OPTIONS.map((option) => {
          const isActive = value === option.value;
          const months = getMonthsFromValue(option.value);
          const savings = getSavingsPercentage(option.value);
          
          return (
            <button
              key={option.value}
              type="button"
              className={`period-button ${isActive ? 'active' : ''}`}
              onClick={() => onChange(option.value as ContractLengthValueRestricted)}
              style={{
                fontWeight: isActive ? 'bold' : 'normal',
                fontSize: isActive ? '1.05em' : '1em',
                position: 'relative'
              }}
            >
              <span className="period-text">{months} Month{months !== 1 ? 's' : ''}</span>
              {savings > 0 && (
                <span className="savings-tag">
                  Save {savings}%
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ContractPeriodSelector;